export default __webpack_public_path__ + "static/127-2f0184cd629d4382fd753b962c872510.jpg";